import React from 'react'
import { Row } from 'antd'
import { useComponentLocale } from '../hooks/useComponentLocale'

const UniversalError = ({ code }) => {
	const getLocale = useComponentLocale()

	const title402One = getLocale({ component: 'error_page', section: '402_li_1' })
	const title402Two = getLocale({ component: 'error_page', section: '402_li_2' })
	const title402Three = getLocale({ component: 'error_page', section: '402_li_3' })

	const title404One = getLocale({ component: 'error_page', section: '404_li_1' })
	const title404Two = getLocale({ component: 'error_page', section: '404_li_2' })

	const title332 = getLocale({ component: 'error_page', section: '332title' })
	const title331 = getLocale({ component: 'error_page', section: '331title' })
	const title330 = getLocale({ component: 'error_page', section: '330title' })

	const title429One = getLocale({ component: 'error_page', section: '429_li_1' })
	const title429Two = getLocale({ component: 'error_page', section: '429_li_2' })

	const libraryLocale = getLocale({ component: 'topBar', section: 'library' })
	const settingsLocale = getLocale({ component: 'topBar', section: 'library' })

	const title500One = getLocale({ component: 'error_page', section: '500_li_1' })
	const title500Two = getLocale({ component: 'error_page', section: '500_li_2' })

	const defaultLocale = getLocale({ component: 'error_page', section: 'default' })

	const showErrorByCode = () => {
		switch (code) {
			case 0:
				return (
					<Row>
						<div>
							<p>Unable to connect to the server</p>
							<p>Please check your internet connection and try again.</p>
						</div>
					</Row>
				)
			case 400:
				break
			case 402:
				return (
					<Row>
						<ul>
							<li>{title402One}</li>
							<li>
								{title402Two} <a href='/library'>{libraryLocale}</a>
							</li>
							<li>
								{title402Three} <a href='/settings/subscriptions'>{settingsLocale}</a>
							</li>
						</ul>
					</Row>
				)
			case 404:
				return (
					<Row>
						<div>
							<p>{title404One}</p>
							<p>{title404Two}</p>
						</div>
					</Row>
				)
			case 429:
				return (
					<Row>
						<ul>
							<li>{title429One}</li>
							<li>{title429Two}</li>
						</ul>
					</Row>
				)
			case 331:
				return (
					<Row>
						<span>{title331}</span>
					</Row>
				)
			case 330:
				return (
					<Row>
						<span>{title330}</span>
					</Row>
				)
			case 332:
				return (
					<Row>
						<span>{title332}</span>
					</Row>
				)
			case 418:
				return (
					<Row>
						<span>No hole cards match filter</span>
					</Row>
				)
			case 500:
				return (
					<Row>
						<div>
							<p>{title500One}</p>
							<p>{title500Two}</p>
						</div>
					</Row>
				)
			default:
				return <p>{defaultLocale}</p>
		}
	}

	return showErrorByCode()
}

export default UniversalError
